export const securitySetup = {
  junior: {
    requirements: [
      { name: 'SSH Key Management', description: 'Generate and manage SSH keys for infrastructure access', priority: 'high' },
      { name: 'AWS IAM Setup', description: 'Configure proper IAM roles and policies', priority: 'high' },
      { name: 'VPN Configuration', description: 'Set up secure VPN access to infrastructure', priority: 'high' },
      { name: 'Secret Management', description: 'Use proper secret management tools', priority: 'medium' }
    ],
    procedures: [
      { step: 'Generate SSH key', command: 'ssh-keygen -t ed25519 -C "devops@company.com"' },
      { step: 'Configure AWS CLI', command: 'aws configure --profile company' },
      { step: 'Install Vault CLI', command: 'vault auth -method=aws' },
      { step: 'Set up MFA', command: 'aws sts get-session-token --serial-number arn:aws:iam::account:mfa/user --token-code 123456' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Infrastructure Security', description: 'Implement security best practices for infrastructure', priority: 'high' },
      { name: 'Container Security', description: 'Secure container images and runtime', priority: 'high' },
      { name: 'Network Security', description: 'Configure secure network policies', priority: 'high' },
      { name: 'Compliance Monitoring', description: 'Monitor compliance with security standards', priority: 'medium' }
    ],
    procedures: [
      { step: 'Scan container images', command: 'docker scan my-image:latest' },
      { step: 'Configure network policies', command: 'kubectl apply -f network-policy.yaml' },
      { step: 'Set up security scanning', command: 'helm install falco falcosecurity/falco' },
      { step: 'Enable audit logging', command: 'aws logs create-log-group --log-group-name /aws/apigateway/audit' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Architecture', description: 'Design comprehensive security architecture', priority: 'high' },
      { name: 'Threat Modeling', description: 'Conduct infrastructure threat modeling', priority: 'high' },
      { name: 'Incident Response', description: 'Lead security incident response', priority: 'high' },
      { name: 'Security Governance', description: 'Establish security governance framework', priority: 'medium' }
    ],
    procedures: [
      { step: 'Configure SIEM', command: 'helm install splunk splunk/splunk-enterprise' },
      { step: 'Set up threat detection', command: 'aws guardduty create-detector --enable' },
      { step: 'Implement zero trust', command: 'istioctl install --set values.pilot.env.EXTERNAL_ISTIOD=true' },
      { step: 'Security compliance scan', command: 'inspec exec aws-foundations-cis-baseline' }
    ]
  }
};
